import {AgreementsService} from '../services/agreements.service';
import {AuthService} from '../services/auth.service';
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {EventLogsService} from '../services/event-logs.service';
import {InventoriesService} from '../services/inventories.service';
import {LogoutDialogComponent} from '../logout-dialog/logout-dialog.component';
import {MatDialog, MatDrawer, MatMenuTrigger} from '@angular/material';
import {MatSnackBar, MatSnackBarRef, SimpleSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {SalePointsService} from '../services/sale-points.service';
import {Subscription} from 'rxjs';

@Component({
  styleUrls: ['./main-nav.component.scss'],
  templateUrl: './main-nav.component.html'
})
export class MainNavComponent implements OnInit, OnDestroy {
  public initializePage: boolean;
  private insertedInventories: Subscription;
  private insertedSalePoints: Subscription;
  private insertedAgreements: Subscription;
  public sidebarItems: any[];
  public totalNotifications: number;
  public user: any;
  public itemSelected: number;
  public toolbarColor: string;
  isSidebarOpened: boolean;
  eventLogSubscription: Subscription;

  constructor(private agreementsService: AgreementsService,
              private authService: AuthService,
              private eventLogsService: EventLogsService,
              private inventoriesService: InventoriesService,
              private matDialog: MatDialog,
              private matSnackBar: MatSnackBar,
              private router: Router,
              private salePointsService: SalePointsService) {
    this.eventLogSubscription = this.eventLogsService.observe().subscribe(
      (eventNumber) => {
        this.totalNotifications = eventNumber;
      }
    );

    this.initializePage = false;
    this.toolbarColor = 'red';
    this.itemSelected = 0;
    this.sidebarItems = [
      {
        path: '/home',
        title: 'Αρχική',
        icon: 'home'
      }
    ];
    this.isSidebarOpened = false;

    this.totalNotifications = 0;
    this.user = {
      description: '',
      name: ''
    };
  }

  @ViewChild(MatMenuTrigger, {static: false}) contextMenu: MatMenuTrigger;

  public async ngOnInit(): Promise<any> {
    await this.initializeFunctionality();
    this.initializePage = true;
  }

  public async initializeFunctionality() {
    const user = await this.authService.getUser();
    this.user = {
      description: user.role_name,
      name: `${user.name}`
    };

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'technicalManager' ||
      user.role_alternate_name === 'driver' ||
      user.role_alternate_name === 'ownNetworkDistributor' ||
      user.role_alternate_name === 'ownNetworkRepresentative' ||
      user.role_alternate_name === 'districtRepresentative' ||
      user.role_alternate_name === 'salesInspector' ||
      user.role_alternate_name === 'technician' ||
      user.role_alternate_name === 'customerManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'regionalDirector') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
          path: '/refrigerators',
          title: 'Ψυγεία',
          icon: 'kitchen'
        });
      }
    }
    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'driver' ||
      user.role_alternate_name === 'ownNetworkDistributor' ||
      user.role_alternate_name === 'ownNetworkRepresentative' ||
      user.role_alternate_name === 'districtRepresentative' ||
      user.role_alternate_name === 'technicalManager' ||
      user.role_alternate_name === 'technician' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'customerManager' ||
      user.role_alternate_name === 'salesInspector') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
          path: '/inventories',
          title: 'Απογραφές',
          icon: 'assignment'
        });
      }
    }

    if (user.role_alternate_name === 'hqManager') {
      this.sidebarItems.push(
        {
          path: '/sale-points',
          title: 'Σημεία Πώλησης',
          icon: 'storefront'
        },
        {
          path: '/purchase_order_requests',
          title: 'Αιτήσεις Ψυγείων',
          icon: 'format_list_numbered'
        },
        {
          path: '/accessory_loading_commands',
          title: 'Εντολές Φόρτωσης Θηκών',
          icon: 'arrow_forward'
        },
        {
          path: '/loading_orders',
          title: 'Εντολές Φόρτωσης',
          icon: 'arrow_forward'
        },
        {
          path: '/returns',
          title: 'Εντολές Επιστροφής',
          icon: 'assignment_return'
        },
        {
          path: '/repairs',
          title: 'Εντολές Επισκευής',
          icon: 'build'
        },
        {
          path: '/super-market-budget',
          title: 'Budget Super Market',
          icon: 'euro_symbol'
        });
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'technicalManager' ||
      user.role_alternate_name === 'driver' ||
      user.role_alternate_name === 'ownNetworkDistributor' ||
      user.role_alternate_name === 'ownNetworkRepresentative' ||
      user.role_alternate_name === 'districtRepresentative' ||
      user.role_alternate_name === 'salesInspector' ||
      user.role_alternate_name === 'technician' ||
      user.role_alternate_name === 'customerManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'regionalDirector') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
          path: '/sale-points',
          title: 'Σημεία Πώλησης',
          icon: 'storefront'
        });
        this.sidebarItems.push({
          path: '/representatives',
          title: 'Αντιπρόσωποι',
          icon: 'group'
        });
      }
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'technicalManager' ||
      user.role_alternate_name === 'driver' ||
      user.role_alternate_name === 'ownNetworkDistributor' ||
      user.role_alternate_name === 'ownNetworkRepresentative' ||
      user.role_alternate_name === 'districtRepresentative' ||
      user.role_alternate_name === 'salesInspector' ||
      user.role_alternate_name === 'technician' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'regionalDirector') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
          path: '/distributionCenters',
          title: 'Κέντρα Διανομής',
          icon: 'share'
        });
      }
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'technicalManager') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
          path: '/purchase_orders',
          title: 'Αγορές',
          icon: 'shopping_cart'
        });
      }
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager') {
        this.sidebarItems.push({
          path: '/refrigerator_transfers',
          title: 'Αλληλομεταφορές Ψυγείων',
          icon: 'autorenew'
        });
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'customerManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'technicalManager') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
            path: '/purchase_order_requests',
            title: 'Αιτήσεις Ψυγείων',
            icon: 'format_list_numbered'
          },
          {
            path: '/accessory_loading_commands',
            title: 'Εντολές Φόρτωσης Θηκών',
            icon: 'arrow_forward'
          },
          {
            path: '/loading_orders',
            title: 'Εντολές Φόρτωσης',
            icon: 'arrow_forward'
          },
          {
            path: '/receipt_orders',
            title: 'Εντολές Παραλαβής',
            icon: 'arrow_back'
          },
          {
            path: '/returns',
            title: 'Εντολές Επιστροφής',
            icon: 'assignment_return'
          },
          // {
          //   path: '/statistics',
          //   title: 'Στατιστικά',
          //   icon: 'bar_chart'
          // },
          {
            path: '/refrigerator-budget',
            title: 'Budget Νέων',
            icon: 'euro_symbol'
          },
          {
            path: '/refrigerator-old-budget',
            title: 'Budget Μεταχειρισμένων',
            icon: 'euro_symbol'
          }
        );
      }
    }
    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'technicalManager') {
      this.sidebarItems.push({
          path: '/super-market-budget',
          title: 'Budget Super Market',
          icon: 'euro_symbol'
        });
    }

    if (user.role_alternate_name === 'basicUser' || user.role_alternate_name === 'customerManager'
      || user.role_alternate_name === 'salesDirector') {
      this.sidebarItems.push(
        {
          path: '/agreements',
          title: 'Συμφωνίες',
          icon: 'people'
        },
        {
          path: '/distribution-limits',
          title: 'Όρια  συμφωνιών',
          icon: 'calculate'
        });
    }

    if (user.role_alternate_name === 'basicUser' || user.role_alternate_name === 'customerManager'
      || user.role_alternate_name === 'salesDirector') {
      this.sidebarItems.push({
        path: '/questionaires',
        title: 'Ερωτηματολόγια',
        icon: 'content_paste'
      });
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'technicalManager' ||
      user.role_alternate_name === 'technicalManagerNew' ||
      user.role_alternate_name === 'callCenterManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'customerManager') {
      this.sidebarItems.push(
        {
          path: '/repairs',
          title: 'Εντολές Επισκευής',
          icon: 'build'
        });

      if (user.is_internal === 1 && user.role_alternate_name !== 'technicalManagerNew') {
        this.sidebarItems.push({
          path: '/logs',
          title: 'Logs επισκευών',
          icon: 'folder_shared'
        });
      }
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'technicalManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'customerManager'
    ) {
      this.sidebarItems.push({
        path: '/maintenance',
        title: 'Εντολές Συντήρησης',
        icon: 'gavel'
      });
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'technicalManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'customerManager') {
      if (user.is_internal === 1) {
        this.sidebarItems.push(
          {
            path: '/promo',
            title: 'Αιτήσεις Διαφημιστικών',
            icon: 'beach_access'
          });
      }
    }

    if (user.role_alternate_name === 'basicUser' || user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'technicalManager') {
      if (user.is_internal === 1) {
        this.sidebarItems.push(
          {
            path: '/withdrawal',
            title: 'Αιτήσεις Απόσυρσης',
            icon: 'kitchen'
          },
          {
            path: '/recycle',
            title: 'Εντολές Ανακύκλωσης',
            icon: 'recycling'
          },
          {
            path: '/sale',
            title: 'Εντολές Πώλησης',
            icon: 'currency_exchange'
          }
        );
      }
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'customerManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'technicalManager') {
      if (user.is_internal === 1) {
        this.sidebarItems.push(
          {
            path: '/users',
            title: 'Χρήστες',
            icon: 'people'
          });
      }
    }

    if (user.role_alternate_name === 'basicUser' || user.role_alternate_name === 'transportManager' || user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'technicalManager' || user.role_alternate_name === 'customerManager') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
          path: '/evaluation',
          title: 'Αξιολογήσεις',
          icon: 'star'
        });
        this.sidebarItems.push({
          path: '/settings',
          title: 'Ρυθμίσεις',
          icon: 'settings'
        });
      }
    }

    if (user.role_alternate_name === 'basicUser') {
      if (user.is_internal === 1) {
        this.sidebarItems.push({
            path: '/sap_logs',
            title: 'Κινήσεις SAP',
            icon: 'text_snippet'
          });
      }
    }

    if (user.role_alternate_name === 'basicUser' ||
      user.role_alternate_name === 'transportManager' ||
      user.role_alternate_name === 'salesDirector' ||
      user.role_alternate_name === 'customerManager') {
      this.totalNotifications = this.eventLogsService.totalEvents;

      this.insertedInventories = this.inventoriesService.insertedInventories.subscribe((inventory) => {
        if (this.userCanSeeNotification(user, inventory)) {
          this.raiseEvents();
          this.showSnackBar(inventory);
        }
      });

      this.insertedSalePoints = this.salePointsService.insertedSalePoints.subscribe((salePoint) => {
        if (this.userCanSeeNotification(user, salePoint)) {
          this.raiseEvents();
          this.showSnackBar(salePoint);
        }
      });

      this.insertedAgreements = this.agreementsService.insertedAgreements.subscribe((agreement) => {
        if (this.userCanSeeNotification(user, agreement)) {
          this.raiseEvents();
          this.showSnackBar(agreement);
        }
      });
    }
  }

  private userCanSeeNotification(user: any, notification: any): boolean {
    if (user.role_alternate_name === 'basicUser' || user.role_alternate_name === 'salesDirector') {
      return true;
    } else {
      if (user.sales_group_ids) {
        const groups = user.sales_group_ids.split(',');
        const exists = groups.find(group => notification.sales_group_id === +group);
        return !!exists;
      }
    }
  }

  public showNotifications(): boolean {
    if (this.user && this.initializePage) {
      return this.authService.isUserBelongsTo('basicUser') ||
        this.authService.isUserBelongsTo('transportManager') ||
        this.authService.isUserBelongsTo('salesDirector') ||
        this.authService.isUserBelongsTo('customerManager');
    } else {
      return false;
    }
  }

  private showSnackBar(eventLog: any): void {
    const snackBarRef: MatSnackBarRef<SimpleSnackBar> = this.matSnackBar.open(eventLog.message,
      'Δείτε περισσότερα', {
        duration: 10000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
      });

    snackBarRef.onAction().subscribe(() => {
      if (eventLog.model === 'sale-point-version') {
        this.router.navigate([eventLog.model, eventLog.id]);
      } else {
        this.router.navigate([eventLog.model, eventLog.model_id]);
      }
    });
  }

  public logout(): void {
    this.matDialog.open(LogoutDialogComponent);
  }

  public navigateToHelp(): void {
    this.router.navigate(['help']);
  }

  public navigateToNotifications(): void {
    this.router.navigate(['notifications']);
  }

  public navigateToUser(): void {
    this.router.navigate(['me']);
  }

  openNavigationItemInANewTab(item: any) {
    const link = this.router.serializeUrl(this.router.createUrlTree([item.path]));
    window.open(`#${link}`, '_blank');
  }


  public resetSidebar(): void {
    this.isSidebarOpened = false;
  }

  public setSidebarMode(): any {
    return window.innerWidth < 1100 ? 'over' : 'side';
  }

  public showMenuButton(): boolean {
    return window.innerWidth < 1100;
  }

  public toggleSidebar(drawer: MatDrawer): void {
    this.isSidebarOpened = true;

    drawer.toggle();
  }

  public showSidebar(): boolean {
    return window.innerWidth < 1100 ? this.isSidebarOpened : true;
  }

  public fetchDescription() {
    return this.totalNotifications > 100 ? '99+' : this.totalNotifications;
  }

  public fetchToolTip() {
    return `Πλήθος: ${this.totalNotifications}`;
  }

  ngOnDestroy(): void {
    this.eventLogSubscription.unsubscribe();
    if (this.user && (this.authService.isUserBelongsTo('basicUser') ||
      this.authService.isUserBelongsTo('transportManager') ||
      this.authService.isUserBelongsTo('salesDirector') ||
      this.authService.isUserBelongsTo('customerManager'))) {
      this.insertedInventories.unsubscribe();
      this.insertedAgreements.unsubscribe();
      this.insertedSalePoints.unsubscribe();
    }

  }

  raiseEvents() {
    this.eventLogsService.raiseEventNumber();
  }
}
